import { FormHelperText } from "@mui/material";

const CheckboxHelper = ({ children, ...props }) => {
  return (
    <FormHelperText
      sx={{
        position: "relative",
        color: "var(--secondary)",
        fontSize: 12,
        letterSpacing: 0,
        lineHeight: "14px",
        left: 30,
      }}
      {...props}
    >
      {children}
    </FormHelperText>
  );
};

export default CheckboxHelper;
